import styled from 'styled-components/macro';
import { StandardBottomMargin } from '../../../../shared-styles';

export const Container = styled.div`
  ${StandardBottomMargin}
  width: 160px;
  margin-right: 20px;
  position: relative;
`;

export const StyledSvg = styled.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
  width: '20px',
  height: '20px',
  viewBox: '0 0 20 20',
})`
  display: ${({ show }) => (show ? 'block' : 'none')};
  fill: #CCCCCC;
  top: 22px;
  right: 20px;
  position: absolute;
  transition: fill 150ms ease 0s;
  :hover {
    cursor: pointer;
    fill: #999999;
  }
`;
